import ReactDOM from 'react-dom/client';
import { MbmProvider } from '@amzn/react-arb-tools';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getMbmOptions } from './translationHelper';
import arbManifest from './i18n/arbManifest';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <MbmProvider {...getMbmOptions(arbManifest)}>
    <App />
  </MbmProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
